import { ReactNode } from 'react';
import EmptyState from './EmptyState';

interface EmptyGridOverlayProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

/**
 * Drop-in replacement for MUI DataGrid `slots.noRowsOverlay`.
 * Use via:
 *   <DataGrid
 *     slots={{ noRowsOverlay: () => <EmptyGridOverlay title="No employees yet" ... /> }}
 *   />
 */
export default function EmptyGridOverlay(props: EmptyGridOverlayProps) {
  return (
    <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
      <EmptyState dense {...props} />
    </div>
  );
}
